import { withNamespaces } from "react-i18next"
import Accordion from 'react-bootstrap/Accordion';
import { Card, CardBody, Col, Row } from "reactstrap";
import DateUtils from "src/services/utils/DateUtils";
import { buildNestedObject } from "../../helpers";
import { RiAlertLine, RiFileWarningLine, RiGovernmentLine, RiShieldUserLine } from "react-icons/ri";
import { KeysTitles } from "../../constants";
import { INTERNATIONAL_DATE_FORMAT } from 'src/common/constants';

const NegativeInfo = ({
    t,
    activeAccordion,
    setActiveAccordion,

    detailsQuery
}) => {
    if (detailsQuery.isFetching) {
        return (
            <Row>
                <Col 
                    sm="12" 
                    className="mt-4 mb-4"
                >
                    <div 
                        className="dt-field dt-skeleton" 
                        style={{ width: '100%', height: '100px' }}
                    />
                </Col>
            </Row>
        )
    }

    const dateUtils = new DateUtils();

    const organizationData = JSON.parse(detailsQuery.data?.company?.organizationData || "");

    const negative_info = buildNestedObject(organizationData?.negative_information?.generic || []);

    const preferentialRightsDetails = negative_info?.preferentialRightsDetails;

    return (
        <Accordion.Item
            onClick={() => setActiveAccordion('negative-info')}
            className={activeAccordion === 'negative-info' ? 'active' : ''}
            eventKey={'negative-info'}
        >
            <Accordion.Header>
                <RiAlertLine size="24" className="me-2" />
                <span>
                    {t('Legal & Negative Information')}
                </span>
            </Accordion.Header>

            <Accordion.Body>

                {/* General Monitoring Info */}
                <Card className="h-100 h-100 shadow-sm mb-4">
                    <CardBody className="p-1">
                        <div className="d-flex align-items-center mb-2">
                            <span className="me-2 text-primary">
                                <RiFileWarningLine size="24" />
                            </span>

                            <div className="fw-bold font-size-16">
                                {t('Monitoring Information')}
                            </div>
                        </div>

                        <Row>
                            {['companyMonitoredSince', 'monitoredStoppedSince', 'statusOfMonitoring', 'numberOfActivePreferentialRights', 'currency'].map(key => (
                                <Col sm="6" key={key} className="mb-1">
                                    <strong className="me-1">
                                        {t(KeysTitles[key]?.title || key)}:
                                    </strong> 
                                    {key === 'companyMonitoredSince' || key === 'monitoredStoppedSince' ? (
                                        dateUtils.convertDateToDate(preferentialRightsDetails[key], INTERNATIONAL_DATE_FORMAT)
                                    ) : preferentialRightsDetails[key]}
                                </Col>
                            ))}
                        </Row>
                    </CardBody>
                </Card>

                {/* Social Security & Pension Funds */}
                {preferentialRightsDetails.socialSecurityAndPensionFunds && (
                    <Card className="h-100 h-100 shadow-sm mb-4">
                        <CardBody className="p-1">
                            <div className="d-flex align-items-center mb-2">
                                <span className="me-2 text-primary">
                                    <RiShieldUserLine size="24" />
                                </span>

                                <div className="fw-bold font-size-16">
                                    {t('Social Security & Pension Funds')}
                                </div>
                            </div>

                            <Row>
                                {Object.entries(preferentialRightsDetails.socialSecurityAndPensionFunds).map(([key, value]) => (
                                    <Col sm="6" key={key} className="mb-1">
                                        <strong>
                                            {t(KeysTitles[key]?.title || key)}:
                                        </strong> {value}
                                    </Col>
                                ))}
                            </Row>
                        </CardBody>
                    </Card>
                )}

                {/* Tax Office */}
                {preferentialRightsDetails.taxOffice && (
                    <Card className="h-100 h-100 shadow-sm mb-4">
                        <CardBody className="p-1">
                            <div className="d-flex align-items-center mb-2">
                                <span className="me-2 text-primary">
                                    <RiGovernmentLine size="24" />
                                </span>

                                <div className="fw-bold font-size-16">
                                    {t('Tax Office')}
                                </div>
                            </div>

                            <Row>
                                {Object.entries(preferentialRightsDetails.taxOffice).map(([key, value]) => (
                                    <Col sm="6" key={key} className="mb-1">
                                        <strong>
                                            {t(KeysTitles[key]?.title || key)}:
                                        </strong> {value}
                                    </Col>
                                ))}
                            </Row>
                        </CardBody>
                    </Card>
                )}
            </Accordion.Body>
        </Accordion.Item>
    )
}

export default withNamespaces()(
    NegativeInfo
)